import {
  Scoreboard,
  ScoreboardParticipant,
  ScoreboardParticipants,
  ScoreboardScore,
  ScoreboardScores
} from '@ps/isp-web-component-library';
import type { EnrichedParticipants } from '@ps/isp-web-services-types';
import type { TableTennisFixture } from '@ps/web-shared-generated-graphql/sports';
import { EventTypeId } from '@ps/web-sports-enums';
import React from 'react';

import { getScoreCharacterLength } from '@swf/sports/utils/getScoreCharacterLength';

interface Props {
  enrichedParticipants?: EnrichedParticipants;
  fixture?: TableTennisFixture;
}

const getParticipantScore = (
  participant: EnrichedParticipants[number],
  score: TableTennisFixture['setsWon'] | undefined
) => (participant.type === 'HOME' ? score?.home : score?.away);

const TableTennisScoreboard = ({ enrichedParticipants, fixture }: Props) => {
  const [participantA, participantB] = enrichedParticipants ?? [];
  const currentSet = fixture?.currentSet;
  const currentSetScore = currentSet?.score;
  const setsWon = fixture?.setsWon;

  return (
    <Scoreboard variant="lite">
      <ScoreboardParticipants>
        <ScoreboardParticipant name={participantA.participant} />
        <ScoreboardParticipant name={participantB.participant} />
      </ScoreboardParticipants>
      <ScoreboardScores>
        <ScoreboardScore
          score={[
            getParticipantScore(participantA, setsWon) ?? null,
            getParticipantScore(participantB, setsWon) ?? null
          ]}
        />
        <ScoreboardScore
          score={[
            getParticipantScore(participantA, currentSetScore) ?? null,
            getParticipantScore(participantB, currentSetScore) ?? null
          ]}
          scoreCharacterLength={getScoreCharacterLength(EventTypeId.TABLE_TENNIS, [
            currentSetScore?.home ?? 0,
            currentSetScore?.away ?? 0
          ])}
        />
      </ScoreboardScores>
    </Scoreboard>
  );
};

export default TableTennisScoreboard;
